import AutoQuery from "servicestack/auto-query/auto-query";
import orderLabels from "emun.order/_labels";
import orderConfig from "emun.order/order.config";
import ServiceBus from "servicestack/service-bus";
import CartController from "emun.cart/cart.controller";
//import CartItem from "emun.cart/cart-item.model";

export default class InactiveOrdersListController extends CartController {
	constructor($cart) {
		super($cart);
		const $ctrl = this;
		$ctrl.labels = orderLabels;
		$ctrl.bus = new ServiceBus();
		var filters = [];
		orderConfig.filters.forEach(function (obj) {
			filters.push(obj);
		});
		$ctrl.query = new AutoQuery({
			url: "QueryCartsJoin.json?OnlyInactive=1",
			orderBy: "-OrderedOn,-Id",
			disableQueryString: !!$ctrl.disableQueryString,
			pageSize: 12,
			filters,
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			autoLoad: true,
			sortOptions: {
				Id: "Order #: Low to High",
				"-Id": "Order #: High to Low",
				"Status,-Id": "Status: A to Z",
				"-Status,-Id": "Status: Z to A",
				"PurchaseOrder,-Id": "PO #: Low to High",
				"-PurchaseOrder,-Id": "PO #: High to Low",
				"VendorLabel,-Id": "Vendor: A to Z",
				"-VendorLabel,-Id": "Vendor: Z to A",
				"CompanyName,-Id": "Customer: A to Z",
				"-CompanyName,-Id": "Customer: Z to A",
				"OrderedOn,-Id": "Order Date: Newest",
				"-OrderedOn,-Id": "Order Date: Oldest",
				"ShipOn,-Id": "Ship Date: Newest",
				"-ShipOn,-Id": "Ship Date: Oldest",
				"GrandTotal,-Id": "Amount: Low to High",
				"-GrandTotal,-Id": "Amount: High to Low",
			}
		});
		$ctrl.$on("cartActivated", (e, cart) => $ctrl.query.load(true));
	}
}
